import { queryOptions } from "@tanstack/react-query";
import { getAthleteAssignedProgram, searchPrograms } from "api-client";

import {
  type ProgramDetail,
  type ProgramList,
  type ProgramListInput,
  type ProgramsRepository,
} from "./ProgramsRepository";

interface CreatePrivatePartnershipProgramsRepositoryParams {
  athleteId: string;
  partnershipId: string;
}

export function createPrivatePartnershipProgramsRepository(
  params: CreatePrivatePartnershipProgramsRepositoryParams,
) {
  const rootKey = [
    "programs",
    "private-partnership",
    params.partnershipId,
  ] as const;
  const repository = {
    listOptions(input: ProgramListInput) {
      return queryOptions<ProgramList>({
        queryKey: [...rootKey, "list", input],
        async queryFn() {
          const response = await searchPrograms({
            query: { ...input, athleteId: params.athleteId },
          });
          return response.data.data;
        },
      });
    },
    detailOptions(programId: string) {
      return queryOptions<ProgramDetail>({
        queryKey: [...rootKey, "detail", programId],
        async queryFn() {
          const response = await getAthleteAssignedProgram({
            path: { id: programId },
          });
          return response.data.data.program;
        },
      });
    },
  };

  return repository satisfies ProgramsRepository;
}
